import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, OnDestroy, Input } from '@angular/core';

import { SAMService } from 'src/app/sam/sam.service';
import { GUIService } from '../../gui.service';
import { ThemeService, InputComponent, Helpers } from 'ngx-elvis-ds';
import { BasePage } from 'ngx-elvis-ds';
import { CartService } from 'src/app/services/cart.service';
import { I18NService } from 'src/app/services/i18n.service';
import { DomController } from '@ionic/angular';
import { ConfigService } from 'src/app/config.service';
import { ImageHelpers } from '../../../base/image-helpers';

export class InputDialogCommands {
  public static OPEN = ['GET_INPUT'];
  public static CLOSE = ['GET_INPUT_CLOSE'];
}

@Component({
  selector: 'app-input-dialog',
  templateUrl: './input-dialog.page.html',
  styleUrls: ['./input-dialog.page.scss'],
})
export class InputDialogPage extends BasePage implements OnInit, OnDestroy {

  @ViewChild('inputDialog', { static: true }) inputDialog: ElementRef;
  @ViewChild('input', { static: true }) input: InputComponent;

  @Input() data: any = {};

  inputOptions: any = {};

  useKeyboard: boolean = true;
  inputData: any;
  reasonData: any = '';
  rewardData: any = '';
  digitsInfo: any = '2.2-2';

  formName: string = 'form' + Helpers.hash();

  get useRelativeKeyboard() {
    return (
      ['number', 'currency'].includes(this.inputOptions.type) &&
      !this.data.Reasons && !this.data.Rewards
    );
  }

  constructor(
    private sam: SAMService,
    private guiSvc: GUIService,
    private cartSvc: CartService,
    public themeSvc: ThemeService,
    public configSvc: ConfigService,
    public i18nSvc: I18NService,
    private domCtrl: DomController,
  ) {
    super();
  }

  ngOnInit() {
    this.init();
    document.addEventListener('keydown', this.initKeyboard);
  }

  ngOnDestroy() {
    document.removeEventListener('keydown', this.initKeyboard);
  }

  ionViewDidEnter() {
    this.domCtrl.write(() => {
      if (this.useKeyboard) {
        if (this.useRelativeKeyboard) {
          this.guiSvc.initLocalKeyboard(this.formName, '#input-keypad-host', false, true, 'input-keypad');
        } else {
          this.guiSvc.initLocalKeyboard(this.formName);
        }
      }
    })
  }
  
  onCallback(success?: Boolean) {
    document.removeEventListener('keydown', this.initKeyboard);
    
    if (success) {
      if (this.inputData) {
        if (this.inputData.toString() === 'NaN') { this.inputData = 0; }

        if (this.data.Callbackconfirm === 'CMD_CREATE_VARIANT') {
          this.cartSvc.variantCache = this.inputData.toString();
        }

        this.sam.onSend({
          Command: 'GENERIC_INPUT',
          Callback: this.data.Callbackconfirm || 'GENERIC_INPUT',
          Val: this.inputData.toString(),
          descr: '',
          parms: {
            usrInp: this.inputData.toString(),
            reason: this.reasonData.toString() || null,
            reward: this.rewardData.toString() || null,
          },
        });
      }
    } else {
      this.sam.onSend({
        Command: 'GENERIC_INPUT',
        Callback: this.data.Callbackabort || 'CANCEL_INPUT',
        Val: '-1'
      });
    }
  }

  onRewardChange() {
    this.input.value = 0;
    this.inputData = 0;
  }

  // private

  private initKeyboard = (evt: any)  => {
    const event = evt || window.event;
    const key = event.key;

    if (key && (key === 'Escape' || key === 'Esc')) { this.onCallback(false); }
    if (key && (key === 'Enter')) { this.onCallback(true); }

    return false;
  }

  private init() {
    this.useKeyboard = /^((?!ios|android|mobile).)*chrome/i.test(navigator.userAgent) && window.innerWidth > 720;

    this.inputOptions = {
      type: 'text',
      value: this.data.Default || '',
      minLength: parseInt(String(this.data.Minlen), 10),
      maxLength: parseInt(String(this.data.Maxlen), 10),
      itemInd: this.data.ItemInd
    };

    switch (this.data.Type) {
      case 'TEXT':
        if (this.inputOptions.value !== '') { this.inputData = this.inputOptions.value.toString(); } else { this.inputData = ''; }
        break;
      case 'ALPHANUMERIC':
        if (this.inputOptions.value !== '') { this.inputData = this.inputOptions.value.toString(); } else { this.inputData = ''; }
        break;
      case 'TEXTAREA':
        this.inputOptions.type = 'textarea';
        if (this.inputOptions.value !== '') { this.inputData = this.inputOptions.value.toString(); } else { this.inputData = ''; }
        break;
      case 'NUMERIC':
        this.inputOptions.type = 'number';
        // if (this.inputOptions.value !== '') { this.inputData = parseInt(this.inputOptions.value, 10); } else { this.inputData = 0; }
        break;
      case 'CURRENCY':
        this.inputOptions.type = 'currency';
        if (this.inputOptions.value !== '') { this.inputData = parseInt(this.inputOptions.value, 10); } else { this.inputData = 0; }
        break;
      case 'NUMERICCURRENCY':
        this.inputOptions.type = 'currency';
        if (this.inputOptions.value !== '') { this.inputData = parseInt(this.inputOptions.value, 10); } else { this.inputData = 0; }
        break;
      case 'FLOAT':
        this.inputOptions.type = 'float';
        if (this.inputOptions.value !== '') { this.inputData = parseInt(this.inputOptions.value, 10); } else { this.inputData = 0; }
        break;
      default:
        if (this.inputOptions.value !== '') { this.inputData = this.inputOptions.value.toString(); } else { this.inputData = ''; }
        break;
    }

    if (this.inputOptions.Decimals) {
      this.digitsInfo = `2.${this.inputOptions.Decimals}-${this.inputOptions.Decimals}`;
    }

    if (parseInt(this.data.Mask, 10) === 1) {
      this.inputOptions.type = 'password';
    }

    if (this.data.Rewards && this.data.Rewards[0]) {
      this.rewardData = this.data.Rewards[0].Id;
    }

    if (this.data.Reasons && this.data.Reasons[0]) {
      this.reasonData = this.data.Reasons[0].Id;
    }

    if (this.data.Image) {
      const imageUrl = ImageHelpers.getImageURL('pos-system-images', this.data.Image, this.configSvc);
      this.data.imageUrl = imageUrl;
    }
  }
}
